import type { BalanceRequest } from '@talos/kyoko';
import { useWLOrgConfigContext, WLBalancesProvider } from '@talos/kyoko';
import { useMemo, type PropsWithChildren } from 'react';

export function GCashBalancesProvider({ children }: PropsWithChildren<unknown>) {
  const favoredPairCurrency = useWLOrgConfigContext().config.favoredPairCurrency;
  const request: Partial<BalanceRequest> = useMemo(
    () => ({ EquivalentCurrency: favoredPairCurrency }),
    [favoredPairCurrency]
  );

  return <WLBalancesProvider initialRequest={request}>{children}</WLBalancesProvider>;
}
